import React from 'react';
import { Box, Heading, IconWrapperProps } from '@common-fe/common-fe';

import theme from '@/styles/theme';

interface BlockWrapperProps {
  Icon: IconWrapperProps;
  title: string;
  children: React.ReactNode;
}

const BlockWrapper: React.FC<BlockWrapperProps> = ({ Icon, title, children }) => (
  <Box margin={{ top: 'spacing48' }}>
    <Box direction="row" align="center">
      <Box
        justify="center"
        align="center"
        width="xxxsmall"
        height="xxxsmall"
        round="full"
        background="iconAccent"
        margin={{ right: 'spacing16', bottom: 'spacing4' }}
      >
        <Icon color={theme.colors.iconOnColor} />
      </Box>
      <Heading level={4} size="medium">
        {title}
      </Heading>
    </Box>
    <Box style={{ position: 'relative' }} margin={{ top: 'spacing16' }}>
      <Box background="module" round="moduleRound" pad="spacing24" style={{ zIndex: 10 }}>
        {children}
      </Box>
    </Box>
  </Box>
);

export default BlockWrapper;
